import { GitCompareArrows, Gitlab } from "lucide-react";
import React from "react";
import { useCodiffLinks } from "../hooks/useCodiffLinks";
import { mrLinkUrl, safeHttpUrl } from "../utils";
import { Tooltip } from "./Tooltip";

// Opens the MR on whichever host the main title link does *not* use, so both
// GitLab and Codiff are always one click away regardless of the setting.
export const AltLinkButton = ({ mr, className = "" }) => {
	const [useCodiff] = useCodiffLinks();

	const url = safeHttpUrl(mrLinkUrl(mr?.webUrl, !useCodiff));

	// Codiff only mirrors GitLab MR URLs. When the rewrite is a no-op both
	// hosts resolve to the same place and this would duplicate the title link.
	if (!url || url === mrLinkUrl(mr?.webUrl, useCodiff)) return null;

	const target = useCodiff ? "GitLab" : "Codiff";
	const Icon = useCodiff ? Gitlab : GitCompareArrows;

	// -mx-1 cancels the hover padding so the glyph keeps the same gap-2 rhythm
	// as the unpadded status icons next to it.
	return (
		<Tooltip content={`Open in ${target}`}>
			<a
				href={url}
				target="_blank"
				rel="noopener noreferrer"
				draggable="false"
				onClick={(e) => e.stopPropagation()}
				aria-label={`Open merge request in ${target}`}
				className={`p-1 -mx-1 rounded hover:bg-[var(--color-bg-secondary)] text-[var(--color-text-secondary)] hover:text-[var(--color-link)] transition-colors ${className}`}
			>
				<Icon className="w-4 h-4" />
			</a>
		</Tooltip>
	);
};

export default AltLinkButton;
